export default {
  title: 'Importovať pracoviská z {dataSource}',
  importWorkplaces: 'Importovať pracoviská',
  next: 'Ďalej',
  previous: 'Späť',
  import: 'Importovať pracoviská',
  retry: 'Skúsiť znova',
  userMapping: {
    header: 'Priradenie používateľov',
    description: 'Qmulus načíta pracoviská pomocou vášho používateľa PT9800 a synchronizuje importované pracoviská pomocou používateľa PT9800 systémového používateľa.',
    currentUser: 'Váš používateľ PT9800',
    systemUser: 'Používateľ PT9800 systémového používateľa',
    loadWorkplacesFailed: 'Pracoviská sa nepodarilo načítať',
    workplacesUnauthorized: 'PT9800 neprijal vášho používateľa PT9800. Vyberte používateľa PT9800 s prístupom k tejto databáze.',
    loadFailed: 'Priradenie používateľov sa nepodarilo načítať',
    saveFailed: 'Priradenie používateľov sa nepodarilo uložiť',
    currentUserMissing: {
      summary: 'Váš používateľ nie je priradený k používateľovi PT9800',
      details: 'Požiadajte správcu používateľov, aby vášho používateľa priradil k používateľovi PT9800 v správe používateľov, a potom import otvorte znova.',
    },
    systemUserReason: {
      summary: 'Prečo systémový používateľ potrebuje používateľa PT9800',
      details: 'Qmulus na pozadí synchronizuje vsázky, signály, alarmy a recepty importovaných pracovísk ako systémový používateľ. Bez používateľa PT9800 pre systémového používateľa zostanú importované pracoviská prázdne.',
    },
    systemUserUnknown: {
      summary: 'Skontrolujte priradenie systémového používateľa',
      details: 'Importované pracoviská sa synchronizujú len vtedy, keď je systémový používateľ priradený k používateľovi PT9800. Požiadajte správcu používateľov, aby to skontroloval v správe používateľov.',
    },
  },
  location: {
    header: 'Lokalita',
    description: 'Vyberte lokalitu, do ktorej sa pracoviská importujú.',
    linkedToOtherDataSource: {
      summary: 'Lokalita patrí inej inštalácii PT9800',
      details: 'Táto lokalita je už prepojená s {dataSources}. Skontrolujte, či ste vybrali správnu lokalitu.',
    },
    notLinked: {
      summary: 'Lokalita bude prepojená',
      details: 'Import prepojí túto lokalitu s {dataSource}.',
    },
  },
  workplaces: {
    header: 'Pracoviská',
    empty: 'Táto inštalácia PT9800 nemá pracoviská, ktoré sa dajú importovať.',
    nameRequired: 'Zadajte názov.',
    licenseExceeded: '{level}: žiadne voľné licencie. Vaša licencia povoľuje {allowed}.',
    licenseLimitReached: 'Dosiahnutý limit licencie',
    licenseUsage: '{level}: použité {used} z {allowed} licencií vrátane vybraných pracovísk.',
  },
  state: {
    waiting: 'Čaká',
    importing: 'Importuje sa',
    imported: 'Importované',
    failed: 'Zlyhalo',
    alreadyImported: 'Už importované',
  },
  progress: {
    current: 'Krok {current} z {total}: {step}',
    finished: 'Import dokončený',
    failed: 'Zlyhalo: {step}',
    step: {
      linkLocation: 'Prepojenie lokality „{name}“ so zdrojom dát',
      createAsset: 'Vytvorenie „{name}“',
      loadChambers: 'Načítanie komôr „{name}“',
      linkAsset: 'Prepojenie „{name}“ so zdrojom dát',
    },
  },
};
